import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { WebhookSubscription } from "src/app/shared/models/focusDataModels/WebhookSubscription";
import { Integrator } from "src/app/shared/models/integrator";

@Component({
	selector: "app-webhook-record",
	templateUrl: "./webhook-record.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class WebhookRecordComponent implements OnInit {
	@Input() integratorList: Integrator[];
	@Output() integratorListChange = new EventEmitter<Integrator[]>();

	@Input() webhookSelected: WebhookSubscription;
	@Output() webhookSelectedChange = new EventEmitter<WebhookSubscription>();

	@Output() webhookDeleteChange = new EventEmitter<WebhookSubscription>();

	selectedIntegrator: Integrator;

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService, private focusData: FocusdataService) {}

	ngOnInit(): void {
		console.log(this.integratorList);
		console.log(this.webhookSelected);
	}

	async save() {
		this.webhookSelected.Active = true;
		this.webhookSelected.LicenseKey = this.selectedIntegrator.licenses.find((i) => i.type === "integrator").key;
		await this.focusData.webhookPostSubscription(this.venueService.subscriptionVenue.value.key, this.webhookSelected);
		this.webhookSelectedChange.emit(this.webhookSelected);
	}
}
